import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postChargeApproval({ body }) {
  return BaseService.post(REST.CHARGE_APPROVAL, body);
}

function postEmailChargeApproval({ body, id }) {
  return BaseService.post(REST.CHARGE_APPROVAL_EMAIL(id), body);
}

function putChargeApproval({ body, id }) {
  return BaseService.put(REST.CHARGE_APPROVAL_ID(id), body);
}

function getChargeApproval(params) {
  return BaseService.get(REST.CHARGE_APPROVAL, {
    params: paramsFilter({ params }),
  });
}

function deleteChargeApproval({ id }) {
  return BaseService.delete(REST.CHARGE_APPROVAL_ID(id));
}

export default {
  postChargeApproval,
  postEmailChargeApproval,
  putChargeApproval,
  getChargeApproval,
  deleteChargeApproval,
};
